import React, { useState, useEffect } from "react";
import QRCodeGenerator from "../../OrganizationManagement/Component/Qrgenerator";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const QrModal = ({ isOpen, toggleModal, data, id }) => {


  // Ensure data is available and orgCode is set
  const user = JSON.parse(localStorage.getItem("user"));
  const orgCode = user?.organizationInfo?.orgCode || id; // If orgCode exists, use it; otherwise, use id

  console.log("🚀 ~ QrModal ~ orgCode:", orgCode);

  // Check if orgCode is valid and construct the URL
  const url = orgCode ? `${window.location.origin}/${orgCode}?source=qr-menu` : "";

  return (
    <Modal isOpen={isOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}></ModalHeader>
      <ModalBody>
        <div>
          <QRCodeGenerator url={url} />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default QrModal;
